/* 孫吳傳・第 11 章：柴桑定策（建安十三年，208）
 * 史實：曹操南下，劉琮投降。孫權召群臣商議，「議者咸曰」不如迎之（《周瑜傳》）；領頭的是孫策託孤的張昭（《張昭傳》注引《江表傳》：「昔駮周瑜、魯肅等議」）。
 *       《魯肅傳》：孫權起身更衣，魯肅追到宇下：「將軍迎操，欲安所歸？」並勸追召周瑜還。
 *       《周瑜傳》：周瑜從鄱陽回來，當眾駁議者：「操雖託名漢相，其實漢賊也」，又數曹軍「用兵之患」四條。
 *       《諸葛亮傳》：諸葛亮在柴桑說孫權（和劉備傳第 7 章同一場），「彊弩之末，勢不能穿魯縞」。
 *       《江表傳》（裴注）：孫權拔刀斫前奏案；當夜周瑜請見，以實校之曹軍不過二十餘萬；孫權撫背「獨卿與子敬與孤同耳」。
 *       《張昭傳》注引《江表傳》：二十一年後孫權稱帝，「如張公之計，今已乞食矣」。
 * 不打仗的一章：
 *   1. 殿上聽群臣議。人心幾乎都偏向降；這時回座位表態，群臣會一起勸阻（少一顆星）。
 *   2. 起身更衣，魯肅追到廊下。 3. 城門見周瑜、館驛見諸葛亮，收集論點。
 *   4. 回殿上駁議：張昭與群臣每提一條理由，站到能回答的人面前（周瑜／魯肅／孔明之言）。
 *   5. 走到奏案前拔刀斫案。 6. 夜裡周瑜請見，撫背；尾聲跳到二十一年後。
 * 演義成分：無。殿上駁議時孫權轉述魯肅、諸葛亮的話是改寫（m.line），原話分別是私下對孫權說的。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, vanish, PEOPLE } from '../kit.ts';
import { HALL, SEAT, DOOR, EAVES, GATE, INN } from '../maps/chaisang.ts';

const DESK = [SEAT[0], SEAT[1] + 70];
const PADS = { zhouyu: [HALL.x + 180, HALL.y - 60, '周瑜'], lusu: [HALL.x + 180, HALL.y + 110, '魯肅'], kongming: [HALL.x + 180, HALL.y + 280, '孔明之言'] };
const WRONG = { zhouyu: ['周瑜', '這一條，瑜答不上，該問別人。'], lusu: ['魯肅', '（低聲）此非肅所能對。'], kongming: ['孫權', '（孔明沒說過這件事……）'] };
// 殿上駁議：議者的理由（前三句是《周瑜傳》「議者咸曰」原文），由誰回答
const DEBATE = [
  { say: [['張昭', '曹公豺虎也，然託名漢相，挾天子以征四方，動以朝廷為辭，今日拒之，事更不順。']], ok: 'zhouyu',
    ans: [['周瑜', '不然。操雖託名漢相，其實漢賊也。'], ['周瑜', '將軍以神武雄才，兼仗父兄之烈，割據江東，尚當橫行天下，為漢家除殘去穢。況操自送死，而可迎之耶？']] },
  { say: [['張昭', '今操得荊州，劉表治水軍，蒙沖鬥艦，乃以千數，操悉浮以沿江，兼有步兵，水陸俱下。此為長江之險，已與我共之矣。']], ok: 'zhouyu',
    ans: [['周瑜', '今北土既未平安，加馬超、韓遂尚在關西，為操後患。且捨鞍馬，仗舟楫，與吳越爭衡，本非中國所長。'], ['周瑜', '又今盛寒，馬無藁草。驅中國士眾遠涉江湖之間，不習水土，必生疾病。此數四者，用兵之患也，而操皆冒行之。']] },
  { say: [['群臣', '而勢力眾寡，又不可論。'], ['群臣', '曹公信上說，水軍八十萬啊……']], ok: 'kongming',
    ans: [['孫權', '孔明說過：曹操之眾，遠來疲弊，輕騎一日一夜行三百餘里，此所謂「彊弩之末，勢不能穿魯縞」者也。'], ['孫權', '且北方之人，不習水戰；荊州之民附操者，逼兵勢耳，非心服也。']] },
  { say: [['群臣', '迎了曹公，將軍依舊不失封侯，江東也免於兵禍。']], ok: 'lusu',
    ans: [['孫權', '諸君迎操，猶不失州郡；孤迎操，欲安所歸？'], ['魯肅', '（向孫權一揖）']] },
];

const TALKS = {
  zhangzhao: [['張昭', '主公，曹公以朝廷之名南下，劉琮已經束手。'], ['張昭', '江東六郡初定，昭受討逆將軍之託，不敢不直言：大計不如迎之。']],
  qun1: [['群臣', '曹軍號稱八十萬，我們怎麼抵擋得了？'], ['群臣', '迎降了，將軍依舊不失封侯之位。']],
  qun2: [['群臣', '江東六郡初定，不宜輕啟戰端……'], ['群臣', '還請將軍三思。']],
  chengpu: [['程普', '老臣跟隨破虜將軍、討逆將軍三十年，從沒怕過誰。'], ['程普', '要打，程普願為前驅！']],
  huanggai: [['黃蓋', '投降？黃蓋這把老骨頭還能打！'], ['黃蓋', '主公若決意一戰，末將自有破曹之計。']],
  lusu: [['孫權', '卿欲何言？'], ['魯肅', '向察眾人之議，專欲誤將軍，不足與圖大事。今肅可迎操耳，如將軍，不可也。'], ['魯肅', '今肅迎操，操當以肅還付鄉黨，品其名位，猶不失下曹從事，累官故不失州郡也。'], ['魯肅', '將軍迎操，欲安所歸？願早定大計，莫用眾人之議也。'], ['孫權', '此諸人持議，甚失孤望；今卿廓開大計，正與孤同，此天以卿賜我也。'], ['魯肅', '周公瑾受使在鄱陽，可速追召還。']],
  zhouyu: [['周瑜', '瑜自鄱陽趕回。聽說殿上都勸主公迎操？'], ['孫權', '子敬說，眾人之議，專欲誤孤。'], ['周瑜', '請主公再召群臣，瑜當著眾人的面，為將軍籌之。']],
  zhugeliang: [['諸葛亮', '海內大亂，將軍起兵據有江東，劉豫州亦收眾漢南，與曹操並爭天下。'], ['諸葛亮', '若能以吳、越之眾與中國抗衡，不如早與之絕；若不能當，何不案兵束甲，北面而事之！'], ['孫權', '苟如君言，劉豫州何不遂事之乎？'], ['諸葛亮', '田橫，齊之壯士耳，猶守義不辱。況劉豫州王室之胄，英才蓋世，若事之不濟，此乃天也，安能復為之下乎！'], ['孫權', '吾不能舉全吳之地，十萬之眾，受制於人。吾計決矣！然豫州新敗之後，安能抗此難乎？'], ['諸葛亮', '曹操之眾，遠來疲弊，聞追豫州，輕騎一日一夜行三百餘里，此所謂「彊弩之末，勢不能穿魯縞」者也。'], ['諸葛亮', '且北方之人，不習水戰；又荊州之民附操者，逼兵勢耳，非心服也。']],
  night: [['周瑜', '諸人徒見操書，言水步八十萬，而各恐懾，不復料其虛實，便開此議，甚無謂也。'], ['周瑜', '今以實校之，彼所將中國人，不過十五六萬，且軍已久疲；所得表眾，亦極七八萬耳，尚懷狐疑。'], ['周瑜', '夫以疲病之卒，禦狐疑之眾，眾數雖多，甚未足畏。得精兵五萬，自足制之，願將軍勿慮。']],
};

export default {
  id: 'sunwu-11', map: 'chaisang', hero: 'sunquan',
  gold: 0, // 不打仗的章不給軍資
  title: '第 10 章　柴桑定策', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '權起更衣，肅追於宇下。', src: '《三國志·吳書·魯肅傳》' }],
    text: '曹操取荊州，劉琮投降，大軍順江而下，寫信給孫權說「今治水軍八十萬眾，方與將軍會獵於吳」。孫權二十六歲，召集群臣商議；第一個站出來主張迎降的，是孫策臨終託付他的張昭。',
    goals: ['在殿裡聽群臣議（還不是表態的時候）', '起身更衣，到殿外的廊下', '見周瑜與諸葛亮', '回殿上，駁倒迎降之議', '斫案'],
  },
  stars: [
    { text: '殿上沒有提早表態', ok: (m) => !m.vars.early },
    { text: '駁議時每一條都一次找對人', ok: (m) => m.vars.q >= DEBATE.length && !m.vars.miss },
    { text: '聽過程普、黃蓋的話', ok: (m) => m.vars.talk.chengpu.heard && m.vars.talk.huanggai.heard },
  ],
  steps: [
    { // 1. 殿上議事
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, 10);
        me.x = SEAT[0]; me.y = SEAT[1];
        V.talk = {}; V.heart = 10; V.miss = 0; V.q = -1; V.earlyN = 0;
        const put = (key, spec, x, y, name) => {
          const [px, py] = SG.MAP.walkable(x, y, SG.MAP.BODY) ? [x, y] : SG.MAP.nearestFree(x, y);
          const u = ally(w, spec, px, py, 6); if (name) u.name = name; u.f = me.x < px ? -1 : 1;
          V.talk[key] = { u, lines: TALKS[key], li: 0, t: -99, heard: false };
          return u;
        };
        put('zhangzhao', PEOPLE.zhangzhao, HALL.x - 320, HALL.y - 40);
        put('qun1', PEOPLE.qunchen, HALL.x - 340, HALL.y + 160, '群臣');
        put('qun2', PEOPLE.qunchen, HALL.x - 300, HALL.y + 320, '群臣');
        put('chengpu', 'chengpu', 1900, 2900);
        put('huanggai', 'huanggai', 2150, 3000);
        V.lusu = put('lusu', 'lusu', HALL.x + 300, HALL.y - 60);
        V.talk.lusu.locked = true; // 魯肅在殿上不說話：要起身更衣、到廊下他才會追上來
        V.zy = put('zhouyu', 'zhouyu', GATE[0] - 300, GATE[1]); V.talk.zhouyu.locked = true; V.zy.x = -9999; // 周瑜還在鄱陽，之後才到城門
        V.kong = put('zhugeliang', 'zhugeliang', INN[0] - 200, INN[1] + 300);
        V.desk = m.folk(DESK[0], DESK[1], { name: '奏案', still: true, near: 1, draw: desk });
        m.card('「舉江東之衆，決機於兩陳之間，與天下爭衡，卿不如我；舉賢任能，各盡其心，以保江東，我不如卿。」', '《孫策傳》（八年前，孫策臨終對孫權說）');
        m.after(5.5, () => m.card('曹公遺權書曰：「近者奉辭伐罪，旄麾南指，劉琮束手。今治水軍八十萬衆，方與將軍會獵於吳。」', '《江表傳》（裴注）'));
        m.after(11, () => m.line('旁白', '孫策臨終把弟弟託給張昭。如今殿上第一個主張迎降的，也是張昭。'));
        m.after(15, () => m.line('提示', '這一章不打仗。走到人身邊就會聽到他的意見。殿上人心都偏向降，現在回座位表態，誰也說不動。'));
        m.obj('heart', '');
        m.obj('hall', '在殿裡聽群臣議', 3);
        for (const k of ['zhangzhao', 'qun1', 'qun2']) m.mark('t_' + k, V.talk[k].u.x, V.talk[k].u.y - 10, '', true, V.talk[k].u);
      },
      tick(m) {
        const V = m.vars, n = ['zhangzhao', 'qun1', 'qun2'].filter((k) => V.talk[k].heard).length;
        m.prog('hall', n);
        return n >= 3;
      },
    },
    { // 2. 起身更衣：魯肅追到廊下
      enter(m) {
        m.done('hall');
        m.line('孫權', '……容孤更衣。');
        m.mark('eaves', EAVES[0], EAVES[1], '殿外廊下');
        m.obj('eaves', '起身更衣，走到殿外的廊下');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (!V.follow && m.near(me, EAVES[0], EAVES[1], 220)) {
          V.follow = true; m.unmark('eaves');
          m.card('權起更衣，肅追於宇下，權知其意，執肅手曰：「卿欲何言？」', '《魯肅傳》');
          V.talk.lusu.locked = false;
        }
        if (V.follow && !V.talk.lusu.heard && SG.gd(V.lusu.x, V.lusu.y, me.x, me.y) > 120) V.lusu.input.moveTo = [me.x - 80 * (me.f || 1), me.y]; // 魯肅追著孫權
        return V.talk.lusu.heard;
      },
    },
    { // 3. 周瑜回來了、諸葛亮在館驛
      enter(m) {
        const V = m.vars;
        m.done('eaves');
        V.zy.x = GATE[0] + 120; V.zy.y = GATE[1]; V.talk.zhouyu.locked = false;
        m.line('傳令', '周都督從鄱陽回來了，正在城門！');
        m.line('旁白', '諸葛亮奉劉豫州之命而來，在館驛等候。');
        m.mark('zy', V.zy.x, V.zy.y, '周瑜');
        m.mark('zgl', V.kong.x, V.kong.y, '諸葛亮');
        m.obj('two', '見周瑜與諸葛亮', 2);
      },
      tick(m, w) {
        const V = m.vars, n = (V.talk.zhouyu.heard ? 1 : 0) + (V.talk.zhugeliang.heard ? 1 : 0);
        if (V.talk.zhouyu.heard) { m.unmark('zy'); follow(V.zy, w.player); }
        if (V.talk.zhugeliang.heard) m.unmark('zgl');
        m.prog('two', n);
        return n >= 2;
      },
    },
    { // 4. 回殿上駁議
      enter(m, w) {
        const V = m.vars;
        m.done('two');
        m.line('孫權', '再召群臣！');
        m.mark('seat', SEAT[0], SEAT[1], '殿上');
        m.obj('back', '回到殿上');
        V.lusu.input.moveTo = [PADS.lusu[0] + 110, PADS.lusu[1]];
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (V.q < 0) {
          follow(V.zy, me);
          if (!m.near(me, SEAT[0], SEAT[1], 260)) return false;
          m.unmark('seat'); m.done('back');
          V.zy.input.moveTo = [PADS.zhouyu[0] + 110, PADS.zhouyu[1]];
          V.lusu.input.moveTo = [PADS.lusu[0] + 110, PADS.lusu[1]];
          m.line('提示', '議者每提一條理由，就站到能回答的人面前：周瑜、魯肅，或孔明說過的話。');
          m.obj('debate', '駁倒迎降之議', DEBATE.length);
          ask(m, 0);
          return false;
        }
        if (!V.asking) return V.q >= DEBATE.length && V.debated;
        for (const [k, [x, y]] of Object.entries(PADS)) {
          m.chanAt(me, 'pad-' + k + '-' + V.tries, x, y, 70, 1, '請他回答', () => {
            V.tries++;
            const d = DEBATE[V.q];
            if (k !== d.ok) { V.miss++; m.line(WRONG[k][0], WRONG[k][1]); return; }
            V.asking = false; V.okKey = null;
            d.ans.forEach((L, i) => m.after(i * 4.5, () => m.line(L[0], L[1])));
            m.after(d.ans.length * 4.5, () => {
              V.heart = Math.min(90, V.heart + 20); m.prog('debate', V.q + 1);
              if (V.q + 1 < DEBATE.length) ask(m, V.q + 1);
              else { V.q = DEBATE.length; m.line('群臣', '……'); m.after(2, () => { V.debated = true; }); }
            });
          });
        }
        return false;
      },
    },
    { // 5. 斫案
      enter(m) {
        m.done('debate');
        m.line('張昭', '然則……');
        m.mark('desk', DESK[0], DESK[1], '奏案');
        m.obj('desk', '拔刀，斫前奏案');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        m.chanAt(me, 'cut', DESK[0], DESK[1], 150, 1, '拔刀', () => { V.cut = true; });
        return !!V.cut;
      },
    },
    { // 6. 與此案同；當夜，周瑜請見
      enter(m, w) {
        const V = m.vars;
        m.done('desk'); m.unmark('desk');
        V.desk.broken = true; V.heart = 100;
        w.fx({ k: 'spark', x: DESK[0], y: DESK[1] - 30, col: '#ffe0a0' });
        m.big('斫案！');
        m.card('權拔刀斫前奏案曰：「諸將吏敢復有言當迎操者，與此案同！」', '《江表傳》（裴注）');
        m.after(6, () => {
          V.night = true; m.big('及會罷之夜');
          for (const id of ['t_zhangzhao', 't_qun1', 't_qun2', 'zgl']) m.unmark(id);
          for (const k of ['zhangzhao', 'qun1', 'qun2', 'chengpu', 'huanggai', 'zhugeliang']) { vanish(w, V.talk[k].u); V.talk[k].locked = true; }
          V.zy.x = DOOR[0] - 60; V.zy.y = DOOR[1] - 120; V.zy.input.moveTo = null;
          V.lusu.x = DOOR[0] + 60; V.lusu.y = DOOR[1] - 120; V.lusu.input.moveTo = null;
          V.talk.night = { u: V.zy, lines: TALKS.night, li: 0, t: -99, heard: false };
          m.mark('zy', V.zy.x, V.zy.y, '周瑜請見');
          m.obj('night', '夜裡，周瑜請見');
        });
      },
      tick(m) {
        const V = m.vars;
        if (!V.talk.night || !V.talk.night.heard || V.end) return false;
        V.end = true; m.unmark('zy'); m.done('night');
        m.after(2, () => m.card('權撫背曰：「公瑾，卿言至此，甚合孤心。子布、文表諸人，各顧妻子，挾持私慮，深失所望，獨卿與子敬與孤同耳，此天以卿二人贊孤也。」', '《江表傳》（裴注）'));
        m.after(8, () => m.line('孫權', '五萬兵難卒合，已選三萬人，船糧戰具俱辦，卿與子敬、程公便在前發。'));
        m.after(13, () => m.big('二十一年後　孫權稱帝'));
        m.after(14, () => m.card('權既即尊位，請會百官，歸功周瑜。昭舉笏欲褒讚功德，未及言，權曰：「如張公之計，今已乞食矣。」昭大慙，伏地流汗。', '《張昭傳》注引《江表傳》'));
        m.after(21, () => m.win());
        return false;
      },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!V.talk) return;
    // 走到人身邊（230 內）就聽他說，一句接一句；走開就停
    for (const k in V.talk) {
      const T = V.talk[k], u = T.u;
      if (T.heard || T.locked || !u.alive || SG.gd(u.x, u.y, me.x, me.y) > 230) continue;
      u.f = me.x < u.x ? -1 : 1;
      if (w.t - T.t < 3.6) continue;
      T.t = w.t;
      const L = T.lines[T.li++]; m.line(L[0], L[1]);
      if (T.li >= T.lines.length) { T.heard = true; m.unmark('t_' + k); }
    }
    // 回駁議之前，走開又回到座位上表態：群臣一起勸阻
    if (m.i <= 2) {
      if (!m.near(me, SEAT[0], SEAT[1], 250)) V.leftSeat = true;
      else if (V.leftSeat) m.chanAt(me, 'early' + V.earlyN, SEAT[0], SEAT[1], 110, 1.5, '表態', () => {
        V.early = true; V.earlyN++; V.leftSeat = false;
        m.line('張昭', '將軍！此事關乎江東六郡，豈可遽決？');
        m.line('群臣', '請將軍三思！');
        m.line('孫權', '（……還說不動他們。）');
      });
    }
    if (V.heart != null && m.get('heart')) m.get('heart').text = `殿上人心：主戰 ${V.heart}%`;
  },
  // 殿上駁議：地上三個位置
  ground(ctx, m, view, inView) {
    const V = m.vars;
    if (m.i !== 3 || V.q < 0 || V.q >= DEBATE.length) return;
    const T = view.WS.time;
    ctx.save(); ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.font = '900 22px "Noto Serif TC", serif';
    for (const [x, y, name] of Object.values(PADS)) {
      if (!inView(x, y, 80)) continue;
      ctx.strokeStyle = V.asking ? `rgba(255,212,107,${0.6 + 0.3 * Math.sin(T * 4)})` : 'rgba(90,60,30,.5)'; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.ellipse(x, y, 62, 28, 0, 0, Math.PI * 2); ctx.stroke();
      ctx.fillStyle = 'rgba(60,40,20,.85)'; ctx.fillText(name, x, y);
    }
    ctx.restore();
  },
  // 殿上人心（降 ↔ 戰）；夜色
  overlay(ctx, m, view, x0, y0, vw, vh) {
    const V = m.vars;
    if (V.night) { ctx.fillStyle = 'rgba(12,18,48,.5)'; ctx.fillRect(x0, y0, vw, vh); return; }
    if (V.heart == null) return;
    const z = 1 / view.zoom, W = 320 * z, H = 12 * z, x = x0 + vw / 2 - W / 2, y = y0 + 84 * z, k = V.heart / 100;
    ctx.save();
    ctx.fillStyle = 'rgba(30,30,40,.55)'; ctx.fillRect(x - 4 * z, y - 4 * z, W + 8 * z, H + 8 * z);
    ctx.fillStyle = '#6b7a8f'; ctx.fillRect(x, y, W * (1 - k), H);
    ctx.fillStyle = '#c0503a'; ctx.fillRect(x + W * (1 - k), y, W * k, H);
    ctx.fillStyle = '#fff'; ctx.font = `900 ${14 * z}px "Noto Serif TC", serif`; ctx.textBaseline = 'middle';
    ctx.textAlign = 'right'; ctx.fillText('降', x - 10 * z, y + H / 2);
    ctx.textAlign = 'left'; ctx.fillText('戰', x + W + 10 * z, y + H / 2);
    ctx.restore();
  },
};

function ask(m, q) {
  const V = m.vars, d = DEBATE[q];
  V.q = q; V.tries = (V.tries || 0) + 1;
  d.say.forEach((L, i) => m.after(i * 4.5, () => m.line(L[0], L[1])));
  m.after(d.say.length * 4.5, () => { V.asking = true; V.okKey = d.ok; m.get('debate').text = '駁倒迎降之議：誰來回答？（站到他面前）'; });
}
function follow(u, lead) {
  if (u && SG.gd(u.x, u.y, lead.x, lead.y) > 180) u.input.moveTo = [lead.x + 90 * (lead.f || 1), lead.y + 40];
}
// 奏案：斫了之後斷成兩半
function desk(ctx, f) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 6, 4, 70, 14, 60, 0.3);
  if (!f.broken) {
    poly(ctx, [[-60, 0], [60, 0], [60, -24], [-60, -24]], '#6a4428', 1.8);
    poly(ctx, [[-66, -24], [66, -24], [58, -34], [-58, -34]], '#8a5a34', 1.8);
  } else {
    poly(ctx, [[-60, 0], [-6, 0], [-10, -22], [-60, -14]], '#6a4428', 1.8);
    poly(ctx, [[6, 0], [60, 0], [60, -12], [12, -20]], '#6a4428', 1.8);
  }
  ctx.restore();
}
